import { useContext, useMemo } from 'react';
import AppContext from 'app/AppContext';
import { buildLogger } from '@instinet-analytics/core-lib';

export const useLogger = (source: string) => {
    const { services } = useContext(AppContext);
    const { loggingService } = services;

    return useMemo(() => {
        return buildLogger(source, loggingService);
    }, [source, loggingService]);
};
